import React from 'react'

import EditSectionsList from '../../../../../features/components/Forms/EditForm/EditSectionsList'

import { useTikTokCampaignBudgetEditSections } from './useTikTokCampaignBudgetEditSections'

const TikTokEditSections = ({ campaign, isEditDataLoading }) => {
  const { editSections, sectionsInitialOpenStates } = useTikTokCampaignBudgetEditSections(campaign?.id)

  return (
    <EditSectionsList
      editSections={editSections}
      isEditDataLoading={isEditDataLoading}
      editItemData={campaign}
      sectionsInitialOpenStates={sectionsInitialOpenStates}
    />
  )
}

export default TikTokEditSections
